// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"d947a7b1","891":"c2925c3d"}[chunkId] + ".chunk.css";
};